import React from 'react'

import { Box, Flex, Text } from 'system'
import { Tag } from './Tag'

export const Field = ({ name, type, description, required = false }) => {
  return (
    <Box
      as="tr"
      display="table-row"
      gridTemplateColumns="2fr 1fr 6fr"
      gridColumnGap={4}
      alignItems="center"
      borderBottom="1px solid"
      borderColor="purple.90"
      fontSize="small"
      css={`
        &:last-child {
          border-bottom: 0;
        }
      `}
    >
      <Flex
        alignItems="flex-start"
        as="td"
        display="table-cell"
        flexDirection="column"
        p={2}
      >
        <Text
          fontSize="normal"
          fontWeight="semibold"
          as="h5"
          lineHeight="title"
        >
          {name}
        </Text>
        <Text as="p" color="gray.50" fontSize="tiny">
          {type}
        </Text>
      </Flex>
      <Box as="td" p={2} display="table-cell">
        {required ? (
          <Tag colorScheme="red">Required</Tag>
        ) : (
          <Tag colorScheme="blue">Optional</Tag>
        )}
      </Box>
      <Box as="td" display="table-cell" p={2}>
        <Text as="p" lineHeight="copy">
          {description}
        </Text>
      </Box>
    </Box>
  )
}

export default Field
